import { IDisposalReasonGismtDTO, IDisposalReasonGismtViewDTO } from "../../coreapi-dto/dirs/disposalReasonGismt";
import { IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";

class DisposalReasonGismtRequest extends BaseDirRequest<IDisposalReasonGismtViewDTO, IDisposalReasonGismtDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "disposalreasongismt", token, eventHandler)
    }
}
export default DisposalReasonGismtRequest